/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Dollar/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Dollar({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Dollar",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#724BB7"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Dollar.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ZKdMtq': alignSelf,'--mt-2-ZKdMtq': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZKdMtq': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZKdMtq': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZKdMtq': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZKdMtq': opacity,'--w-10-ZKdMtq': typeof width === 'number' ? `${width}px` : width,'--h-11-ZKdMtq': typeof height === 'number' ? `${height}px` : height,'--f-12-ZKdMtq': fill,'--a-7-ZKdMtq': isAnimated ? animation : "none",'--sd-8-ZKdMtq': isAnimated ? strokeDashoffset : 0,'--sd-9-ZKdMtq': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Dollar.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M14 7A7 7 0 110 7a7 7 0 0114 0zM7.75 3.25a.75.75 0 00-1.5 0v.51a1.866 1.866 0 00-.2 3.678l1.474.323a.5.5 0 01-.107.989h-.834a.5.5 0 01-.471-.333.75.75 0 00-1.415.5c.239.674.83 1.184 1.553 1.305v.528a.75.75 0 001.5 0v-.528a2.001 2.001 0 00.094-3.927l-1.473-.322a.366.366 0 01.078-.723h.968a.497.497 0 01.471.333.75.75 0 101.415-.5A2 2 0 007.75 3.778V3.25z"
 style={{'--f-12-ZKdMtq': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}